import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { components as reactSelectComponents } from 'react-select';
import Button from '~components/button';
import { Divider } from '~components/divider';
import Select from './select';

const useStyles = makeStyles((theme) => ({
  divider: {
    marginLeft: 8,
    marginRight: 8,
  },

  actionButton: {
    ...theme.typography.dropdown,
    padding: '10px 12px',
    color: theme.colors.dark,
  },
}));

const SelectWithActionOptions = React.forwardRef((props, ref) => {
  const {
    actionButtonProps,
    components,
    defaultMenuIsOpen,
    menuIsOpen: menuIsOpenProp,
    onMenuOpen,
    onMenuClose,
    ...otherProps
  } = props;
  const [menuIsOpen, setMenuIsOpen] = useState(defaultMenuIsOpen);

  const handleMenuOpen = (...args) => {
    if (onMenuOpen) onMenuOpen(...args);
    setMenuIsOpen(true);
  };
  const handleMenuClose = (...args) => {
    if (onMenuClose) onMenuClose(...args);
    setMenuIsOpen(false);
  };

  const classes = useStyles();

  const Menu = (MenuProps) => {
    const { children } = MenuProps;

    return (
      <reactSelectComponents.Menu {...MenuProps}>
        {children}
        {actionButtonProps && (
          <>
            <Divider className={classes.divider} />
            <Button
              variant="base"
              {...actionButtonProps}
              className={classNames(classes.actionButton, actionButtonProps?.className)}
              onClick={(...args) => {
                if (actionButtonProps?.onClick) actionButtonProps.onClick(...args);
                handleMenuClose();
              }}
            />
          </>
        )}
      </reactSelectComponents.Menu>
    );
  };

  return (
    <Select
      ref={ref}
      {...otherProps}
      components={{ Menu, ...components }}
      defaultMenuIsOpen={defaultMenuIsOpen}
      menuIsOpen={menuIsOpenProp ?? menuIsOpen}
      onMenuOpen={handleMenuOpen}
      onMenuClose={handleMenuClose}
    />
  );
});

SelectWithActionOptions.propTypes = {
  actionButtonProps: PropTypes.object,
  components: PropTypes.object,
  defaultMenuIsOpen: PropTypes.bool,
  menuIsOpen: PropTypes.bool,
  onMenuOpen: PropTypes.func,
  onMenuClose: PropTypes.func,
};
SelectWithActionOptions.defaultProps = {
  actionButtonProps: undefined,
  components: undefined,
  defaultMenuIsOpen: undefined,
  menuIsOpen: undefined,
  onMenuOpen: undefined,
  onMenuClose: undefined,
};

export default SelectWithActionOptions;
